import { render, staticRenderFns } from "./NumberView.vue?vue&type=template&id=4f74c698&scoped=true&"
import script from "./NumberView.vue?vue&type=script&lang=js&"
export * from "./NumberView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74c698",
  null
  
)

export default component.exports